<template>
  <div>
    <div class="question_body" id="answer">
      <p class="question_result">
        <strong>{{ result }}</strong>
      </p>
      <p>正解は「{{ rightAnswer }}」</p>
    </div>

    <section class="answer">
      <HeadingLv3 text="解説" />
      <div class="answer_body">
        <div v-html="commentary"></div>
        <div v-for="image in images" :key="image.ID">
          <img :src="image.url" :alt="image.alt" />
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'

export default {
  name: 'MasterAnswer',
  props: {
    commentary: String,
    answers: Array,
    answer: Object,
    images: Array
  },
  components: {
    HeadingLv3
  },
  setup(props: any) {
    const result = props.answer.right_flag ? '正解' : '不正解'
    const rightAnswer = props.answers.find((a: any) => a.right_flag).answer
    return {
      result,
      rightAnswer
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.question_result {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: #e7f8f6;
  font-weight: bold;
  font-size: 2.2rem;
  color: var.$color-main-text;

  & + p {
    margin-top: 10px;
    font-size: 1.6rem;
  }
}
.answer {
  margin-top: 50px;
}

.answer_body {
  margin-top: 9px;
  font-size: 1.6rem;
  line-height: 1.875;

  > div + div {
    margin-top: 16px;
  }
}

.backnumberList {
  & + .button {
    margin-top: 32px;
  }
}
</style>
